/** Keep measurement free of visitor-entered content and private note identifiers. */
export const isSensitiveAnalyticsPath = (path: string) =>
  /^\/tools\/secure-note(?:\/|$)/.test(path);

export const redactPath = (path: string) =>
  path.replace(/^\/tools\/secure-note\/view\/[^/]+/, "/tools/secure-note/view/:id");

export const safeAnalyticsUrl = (input: string, origin: string) => {
  const url = new URL(input, origin);
  const safe = new URL(redactPath(url.pathname), url.origin);
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_id"]) {
    const value = url.searchParams.get(key);
    if (value && /^[a-zA-Z0-9_-]{1,80}$/.test(value)) safe.searchParams.set(key, value);
  }
  return safe.toString();
};

export const maintenancePlan = (value: string | null) =>
  value === "essential" || value === "professional" || value === "premium" ? value : undefined;

export const submissionEvent = (type: string, result: unknown) => {
  if (!result || typeof result !== "object" || !("accepted" in result) || result.accepted !== true) return undefined;
  if (type === "review") return "submit_review";
  if (type === "contact" || type === "quote" || type === "meeting") return "generate_lead";
  return undefined;
};